<div data-testid="entity-headroom" class="headroom">
  <div class="headroom__header">
    <div class="headroom__titles">
      <h4 data-testid="headroom-title" class="headroom__title">{{ title }}</h4>
      <p data-testid="headroom-description" class="headroom__description">{{ description }}</p>
    </div>
  </div>
  @if (failed) {
    <app-admin-dashboard-empty data-testid="headroom-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  } @else if (data?.notApplicable) {
    <app-admin-dashboard-empty data-testid="headroom-na" icon="fa-regular fa-address-card" [title]="notApplicableText"></app-admin-dashboard-empty>
  } @else if (hasContent) {
    <div data-testid="headroom-counters" class="headroom__counters">
      @for (counter of counters; track counter.band) {
        <button type="button" class="headroom__counter" [attr.data-band]="counter.band" [attr.data-testid]="'headroom-' + counter.band"
                [disabled]="!counter.count" [attr.title]="counter.count ? 'List them' : null" (click)="openBand(counter.band)">
          <span data-testid="headroom-count" class="headroom__counter-value">{{ int(counter.count) }}</span>
          <span data-testid="headroom-label" class="headroom__counter-label">{{ counter.label }}</span>
        </button>
      }
    </div>
    @if (top.length) {
      <ol data-testid="headroom-top" class="headroom__top" aria-label="Clients closest to or over their licensed entities">
        @for (row of top; track row.companyId) {
          <li data-testid="headroom-row" class="headroom__row" [attr.data-band]="row.band">
            <span data-testid="headroom-name" class="headroom__name">{{ row.companyName || row.companyId }}</span>
            <span data-testid="headroom-use" class="headroom__use">{{ useText(row) }}</span>
            @if (row.reachesLimitOn) {
              <span data-testid="headroom-reaches" class="headroom__reaches">{{ reachesText(row) }}</span>
            }
          </li>
        }
      </ol>
    }
  } @else if (isEmpty) {
    <app-admin-dashboard-empty data-testid="headroom-empty" icon="fa-regular fa-building" [title]="emptyText"></app-admin-dashboard-empty>
  }
</div>
